import {
  LOCAL_STORAGE_KEY,
  __userLocalStorageKey,
} from '../../constants/local-storage';
import { ITSUser } from '../../types/user';
import {
  delayedRedirect,
  setLocation,
  setRedirectTimeout,
  setClassroomMode,
  setCurrentStudentClassroomToken,
  DelayedRedirect,
  setCurrentClassroomToken
} from '../actions/app-actions';
import { updateCurrentUser } from '../actions/firebase-actions';
import { UILocation } from '../reducers/app-reducers';

import { Handler, createClientMiddleware, handle } from './types';


const onSetCurrentStudentClassroomToken: Handler<string> = ({ payload }) => {
  localStorage.setItem(
    __userLocalStorageKey(LOCAL_STORAGE_KEY.currentStudentClassroomToken),
    payload
  );
};

const onSetClassroomMode = handle(setClassroomMode, ({ payload }) => {
  localStorage.setItem(
    __userLocalStorageKey(LOCAL_STORAGE_KEY.classroomMode),
    payload ? 'true' : 'false'
  );
});

const onDelayedRedirect: Handler<DelayedRedirect> = ({
  payload,
  dispatch,
  state,
}) => {
  const { location, delay = 1 } = payload;
  const { redirectTimeout } = state.app;

  if (redirectTimeout) clearTimeout(redirectTimeout);

  const timeout = setTimeout(() => dispatch(setLocation(location)), delay);
  dispatch(setRedirectTimeout(timeout));
};

const onUpdateCurrentUser: Handler<ITSUser | undefined> = ({ payload, dispatch }) => {
  if (!payload) {
    dispatch(setLocation(UILocation.home));
    dispatch(setCurrentClassroomToken(''));
  }
};

export const createAppMiddleware = createClientMiddleware(() => void 0)
  .on(setCurrentStudentClassroomToken, onSetCurrentStudentClassroomToken)
  .on(setClassroomMode, onSetClassroomMode)
  .on(delayedRedirect, onDelayedRedirect)
  .on(updateCurrentUser, onUpdateCurrentUser)
  .build();
